import BaseReducer from "./BaseReducer";

class ImageModalReducer extends BaseReducer {
  domain = "Modals";
  type = "ImageModal";

  initialState = {
    open: false,
    title: "Image",
    image: null,
  };
}

const reducer = new ImageModalReducer();

export default reducer;
